import Projet from "@/generated/classes/Projet";
import { PictoTypes } from "@/generated/classes/Module";
import { typePicto } from "@/framework/base/helpers/Picto";

export default class ProjetExtend  extends Projet {

  constructor() {
    super();
  }
  public static getTitle (projet: Projet): string {
    return projet.nom != '' ? projet.nom : 'Nouveau projet';
  }

  public static getSubtitle (projet: Projet): string {
    // let objet = ''
    // if (projet.objetPoleEmploi != '') {
    //   objet = ' - ' + maskTransform(projet.objetPoleEmploi, 'NN NA NNNNNN NN');
    // }
    return projet.etablissementNom ;
  }

  public static getInfo (projet: Projet): string {
    if (projet.dateDebut && projet.dateDebut > new Date()) {
      return 'Non démarré';
    } else if (projet.dateFin && projet.dateFin < new Date()) {
      return 'Achevé';
    } else {
      return 'En cours';
    }
  }

  public static getData (projet: Projet): string[] {
    const res: string[] = [];
    res.push(ProjetExtend.getTitle(projet));
    res.push(ProjetExtend.getSubtitle(projet));
    res.push(ProjetExtend.getInfo(projet));
    res.push("100");
    return res;
  }

  public static getPicto (projet: Projet): string {
    let res = 'ProjetSpect';
    const projetId = projet.id;
    if (projetId < 0 || projetId % 5 == 0) {
      res = res + "Chant";
    } else if (projetId % 5 == 1) {
      res = res + "Artifice";
    } else if (projetId % 5 == 2) {
      res = res + "Magie";
    } else if (projetId % 5 == 3) {
      res = res + "Danse";
    } else if (projetId % 5 == 4) {
      res = res + "Musical";
    }
    return res;
  }

  // eslint-disable-next-line
  public static getPictoType (projet: Projet): string {
    return typePicto(PictoTypes.ICON);
  }
}
